import { CollectionShort } from "../../types/Collection";
import { Action } from "redux-actions";
import { ADD_COLLECTIONS } from "./actions";

export interface CollectionsState {
	collections: CollectionShort[];
}

export const initialStateCollection: CollectionsState = {
	collections: []
}

export const collectionReducer = (state: CollectionsState = initialStateCollection, action: Action<CollectionShort[]>): CollectionsState => {
	if (action.type === ADD_COLLECTIONS) {
		return {
			...state,
			collections: action.payload
		};
	}

	return state;
};
